module.exports = "<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"WBS\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/wbs/wbs.component.html
// module id = ./src/app/wbs/wbs.component.html
// module chunks = main